import { browserCheck } from '@ta-interaktiv/browsercheck'
export const config = {
  isMobile: browserCheck.isMobile,
  chartHeight: 300,
  roundTo: 100,
  linespace: browserCheck.isMobile ? 3 : 5,
  annoLineHeight: browserCheck.isMobile ? 12 : 18
}
